module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group esma_form_group"
  }, [(_vm.showLabel) ? _c('label', {
    staticClass: "col-xs-4 control-label esma_form_label",
    attrs: {
      "for": _vm.fieldID
    }
  }, [_vm._v(_vm._s(_vm.fieldLabel))]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.fieldClass,
    staticStyle: {
      "padding": "0px 0px 0px 5px"
    }
  }, [_c('input', {
    ref: _vm.fieldID,
    staticClass: "form-control",
    style: (_vm.filedStyle + 'float:left;width: 20px;height:20px;'),
    attrs: {
      "type": "checkbox",
      "disabled": _vm.isDisabled,
      "id": _vm.fieldID,
      "name": _vm.fieldID
    },
    domProps: {
      "value": _vm.fieldValue,
      "checked": _vm.fieldValue == 1
    },
    on: {
      "change": function($event) {
        _vm.updateValue($event.target.value, $event.target)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "float": "left",
      "padding-top": "6px",
      "font-weight": "normal",
      "font-size": "14px"
    },
    attrs: {
      "for": _vm.fieldID
    }
  }, [_vm._v("\n            " + _vm._s(_vm.fieldSubLabel) + "\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64000659","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/checkbox.vue
// module id = 1011
// module chunks = 0